/* tslint:disable */
/* eslint-disable */
/**
 * Digests API
 * Digest Management by Group Admins
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface BannerInclusion
 */
export interface BannerInclusion {
    /**
     * 
     * @type {string}
     * @memberof BannerInclusion
     */
    'startShowing': string;
    /**
     * 
     * @type {string}
     * @memberof BannerInclusion
     */
    'stopShowing': string;
    /**
     * 
     * @type {number}
     * @memberof BannerInclusion
     */
    'index'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BannerInclusion
     */
    'isTop': boolean;
}
/**
 * 
 * @export
 * @interface CreateDigest
 */
export interface CreateDigest {
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'digestName': string;
    /**
     * This is the name that emails will appear to be from. If left blank, the digest name will be used.
     * @type {string}
     * @memberof CreateDigest
     */
    'fromName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'clientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'groupId': string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDigest
     */
    'isDeactivated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDigest
     */
    'includeDiscussions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDigest
     */
    'includeFileShares'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDigest
     */
    'includeEvents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDigest
     */
    'includeMembers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDigest
     */
    'includeTimesOnGroupActivity'?: boolean;
    /**
     * 
     * @type {Array<PromotionalBanner>}
     * @memberof CreateDigest
     */
    'promotionalBanners'?: Array<PromotionalBanner>;
    /**
     * 
     * @type {number}
     * @memberof CreateDigest
     */
    'numberOfDaysInPastEventCutoff'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateDigest
     */
    'numberOfMonthsInFutureEventCutoff'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'lastMemberAnnouncement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateDigest
     */
    'isFrench'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'timingMonthly'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateDigest
     */
    'timingPeriodic'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'timeOfDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'nextEmailDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'brandId'?: string;
    /**
     * 
     * @type {Array<DigestMonitor>}
     * @memberof CreateDigest
     */
    'digestMonitors': Array<DigestMonitor>;
    /**
     * 
     * @type {string}
     * @memberof CreateDigest
     */
    'brand_id'?: string;
}
/**
 * 
 * @export
 * @interface DigestMonitor
 */
export interface DigestMonitor {
    /**
     * 
     * @type {string}
     * @memberof DigestMonitor
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DigestMonitor
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DigestMonitor
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface GetDigest
 */
export interface GetDigest {
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'digestName': string;
    /**
     * This is the name that emails will appear to be from. If left blank, the digest name will be used.
     * @type {string}
     * @memberof GetDigest
     */
    'fromName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'endDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'clientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'groupId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetDigest
     */
    'isDeactivated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDigest
     */
    'includeDiscussions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDigest
     */
    'includeFileShares'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDigest
     */
    'includeEvents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDigest
     */
    'includeMembers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetDigest
     */
    'includeTimesOnGroupActivity'?: boolean;
    /**
     * 
     * @type {Array<PromotionalBanner>}
     * @memberof GetDigest
     */
    'promotionalBanners'?: Array<PromotionalBanner>;
    /**
     * 
     * @type {number}
     * @memberof GetDigest
     */
    'numberOfDaysInPastEventCutoff'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetDigest
     */
    'numberOfMonthsInFutureEventCutoff'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'lastMemberAnnouncement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetDigest
     */
    'isFrench'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'timingMonthly'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetDigest
     */
    'timingPeriodic'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'timeOfDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'nextEmailDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetDigest
     */
    'brand_id'?: string;
}
/**
 * 
 * @export
 * @interface PromotionalBanner
 */
export interface PromotionalBanner {
    /**
     * 
     * @type {string}
     * @memberof PromotionalBanner
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromotionalBanner
     */
    'image'?: string;
    /**
     * 
     * @type {string}
     * @memberof PromotionalBanner
     */
    'clickUrl'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PromotionalBanner
     */
    'isPaid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PromotionalBanner
     */
    'creatorEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PromotionalBanner
     */
    'lastUpdated'?: string | null;
    /**
     * 
     * @type {Array<BannerInclusion>}
     * @memberof PromotionalBanner
     */
    'bannerInclusions': Array<BannerInclusion>;
}
/**
 * 
 * @export
 * @interface UpdateDigest
 */
export interface UpdateDigest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'digestName'?: string;
    /**
     * This is the name that emails will appear to be from. If left blank, the digest name will be used.
     * @type {string}
     * @memberof UpdateDigest
     */
    'fromName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'endDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'clientName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'groupId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDigest
     */
    'isDeactivated'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDigest
     */
    'includeDiscussions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDigest
     */
    'includeFileShares'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDigest
     */
    'includeEvents'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDigest
     */
    'includeMembers'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDigest
     */
    'includeTimesOnGroupActivity'?: boolean;
    /**
     * 
     * @type {Array<PromotionalBanner>}
     * @memberof UpdateDigest
     */
    'promotionalBanners'?: Array<PromotionalBanner>;
    /**
     * 
     * @type {number}
     * @memberof UpdateDigest
     */
    'numberOfDaysInPastEventCutoff'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateDigest
     */
    'numberOfMonthsInFutureEventCutoff'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'lastMemberAnnouncement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDigest
     */
    'isFrench'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'timingMonthly'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDigest
     */
    'timingPeriodic'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'timeOfDay'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'nextEmailDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateDigest
     */
    'brand_id'?: string;
}

/**
 * DigestApi - axios parameter creator
 * @export
 */
export const DigestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint for creating a digest
         * @param {CreateDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestCreate: async (data: CreateDigest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'data' is not null or undefined
            assertParamExists('digestCreate', 'data', data)
            const localVarPath = `/digest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint for fetching list of digests for user
         * @param {Array<string>} groupIds group ids for which to fetch digests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestList: async (groupIds: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupIds' is not null or undefined
            assertParamExists('digestList', 'groupIds', groupIds)
            const localVarPath = `/digest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (groupIds) {
                localVarQueryParameter['groupIds'] = groupIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} digestId 
         * @param {GetDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestPartialUpdate: async (digestId: string, data: GetDigest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'digestId' is not null or undefined
            assertParamExists('digestPartialUpdate', 'digestId', digestId)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('digestPartialUpdate', 'data', data)
            const localVarPath = `/digest/{digest_id}`
                .replace(`{${"digest_id"}}`, encodeURIComponent(String(digestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} digestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestRead: async (digestId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'digestId' is not null or undefined
            assertParamExists('digestRead', 'digestId', digestId)
            const localVarPath = `/digest/{digest_id}`
                .replace(`{${"digest_id"}}`, encodeURIComponent(String(digestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint for sending a digest immediately
         * @param {string} digestId 
         * @param {GetDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestSendCreate: async (digestId: string, data: GetDigest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'digestId' is not null or undefined
            assertParamExists('digestSendCreate', 'digestId', digestId)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('digestSendCreate', 'data', data)
            const localVarPath = `/digest/{digest_id}/send`
                .replace(`{${"digest_id"}}`, encodeURIComponent(String(digestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} digestId 
         * @param {UpdateDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestUpdate: async (digestId: string, data: UpdateDigest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'digestId' is not null or undefined
            assertParamExists('digestUpdate', 'digestId', digestId)
            // verify required parameter 'data' is not null or undefined
            assertParamExists('digestUpdate', 'data', data)
            const localVarPath = `/digest/{digest_id}`
                .replace(`{${"digest_id"}}`, encodeURIComponent(String(digestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Basic required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(data, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DigestApi - functional programming interface
 * @export
 */
export const DigestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DigestApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint for creating a digest
         * @param {CreateDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async digestCreate(data: CreateDigest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDigest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.digestCreate(data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint for fetching list of digests for user
         * @param {Array<string>} groupIds group ids for which to fetch digests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async digestList(groupIds: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetDigest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.digestList(groupIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} digestId 
         * @param {GetDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async digestPartialUpdate(digestId: string, data: GetDigest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDigest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.digestPartialUpdate(digestId, data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} digestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async digestRead(digestId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDigest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.digestRead(digestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint for sending a digest immediately
         * @param {string} digestId 
         * @param {GetDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async digestSendCreate(digestId: string, data: GetDigest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.digestSendCreate(digestId, data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} digestId 
         * @param {UpdateDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async digestUpdate(digestId: string, data: UpdateDigest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateDigest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.digestUpdate(digestId, data, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DigestApi - factory interface
 * @export
 */
export const DigestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DigestApiFp(configuration)
    return {
        /**
         * API endpoint for creating a digest
         * @param {CreateDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestCreate(data: CreateDigest, options?: any): AxiosPromise<GetDigest> {
            return localVarFp.digestCreate(data, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint for fetching list of digests for user
         * @param {Array<string>} groupIds group ids for which to fetch digests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestList(groupIds: Array<string>, options?: any): AxiosPromise<Array<GetDigest>> {
            return localVarFp.digestList(groupIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} digestId 
         * @param {GetDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestPartialUpdate(digestId: string, data: GetDigest, options?: any): AxiosPromise<GetDigest> {
            return localVarFp.digestPartialUpdate(digestId, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} digestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestRead(digestId: string, options?: any): AxiosPromise<GetDigest> {
            return localVarFp.digestRead(digestId, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint for sending a digest immediately
         * @param {string} digestId 
         * @param {GetDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestSendCreate(digestId: string, data: GetDigest, options?: any): AxiosPromise<void> {
            return localVarFp.digestSendCreate(digestId, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} digestId 
         * @param {UpdateDigest} data 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        digestUpdate(digestId: string, data: UpdateDigest, options?: any): AxiosPromise<UpdateDigest> {
            return localVarFp.digestUpdate(digestId, data, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DigestApi - object-oriented interface
 * @export
 * @class DigestApi
 * @extends {BaseAPI}
 */
export class DigestApi extends BaseAPI {
    /**
     * API endpoint for creating a digest
     * @param {CreateDigest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public digestCreate(data: CreateDigest, options?: AxiosRequestConfig) {
        return DigestApiFp(this.configuration).digestCreate(data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint for fetching list of digests for user
     * @param {Array<string>} groupIds group ids for which to fetch digests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public digestList(groupIds: Array<string>, options?: AxiosRequestConfig) {
        return DigestApiFp(this.configuration).digestList(groupIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} digestId 
     * @param {GetDigest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public digestPartialUpdate(digestId: string, data: GetDigest, options?: AxiosRequestConfig) {
        return DigestApiFp(this.configuration).digestPartialUpdate(digestId, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} digestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public digestRead(digestId: string, options?: AxiosRequestConfig) {
        return DigestApiFp(this.configuration).digestRead(digestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint for sending a digest immediately
     * @param {string} digestId 
     * @param {GetDigest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public digestSendCreate(digestId: string, data: GetDigest, options?: AxiosRequestConfig) {
        return DigestApiFp(this.configuration).digestSendCreate(digestId, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} digestId 
     * @param {UpdateDigest} data 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public digestUpdate(digestId: string, data: UpdateDigest, options?: AxiosRequestConfig) {
        return DigestApiFp(this.configuration).digestUpdate(digestId, data, options).then((request) => request(this.axios, this.basePath));
    }
}


